import { Arrange, Container, Loader, Spacer, Text } from '@loomhq/lens';
import React from 'react';

import {
  ANON_NAV_LOGIN_PAGE_CLICKED,
  ANON_NAV_SIGNUP_PAGE_CLICKED,
} from 'constants/events';

import { useFeatureFlagValue } from 'hooks/featureFlag';

import { EXP_NEW_CTA_AND_VALUE_PROP_ON_SHARE_PAGE } from '../../../../../../shared/constants/featureFlag';

import SigninButton from 'components/signin-button';
import SignupButton from 'components/signup-button';

import styles from './styles.module.less';

export default function SignupCallout() {
  const flagValue = useFeatureFlagValue(
    EXP_NEW_CTA_AND_VALUE_PROP_ON_SHARE_PAGE
  );
  let valuePropText = 'Skip the meeting and record a quick video instead.';

  if (flagValue && flagValue.includes('variant')) {
    valuePropText = 'Say more in less time. Record your first loom in seconds.';
  }

  if (flagValue === undefined) {
    return (
      <Container
        position="relative"
        height="7.925rem"
        backgroundColor="background"
        borderSide="all"
        padding="medium"
        radius="medium"
      >
        <Loader className={styles.loaderFadeIn} color="blurple" />
      </Container>
    );
  }

  return (
    <Container
      backgroundColor="background"
      borderSide="all"
      padding="medium"
      radius="medium"
    >
      <Text color="body" fontWeight="medium">
        {valuePropText}
      </Text>
      <Spacer top="medium" />
      <Arrange justifyContent="space-between">
        {flagValue !== 'variant-3' && (
          <SigninButton
            size="small"
            tracking={{
              eventName: ANON_NAV_LOGIN_PAGE_CLICKED,
              properties: {
                from_url: window.location.href,
                source: 'anon-nav',
              },
            }}
          />
        )}
        <SignupButton
          size="small"
          tracking={{
            eventName: ANON_NAV_SIGNUP_PAGE_CLICKED,
            properties: {
              from_url: window.location.href,
              source: 'anon-nav',
            },
          }}
          ctaAndValuePropFlagValue={flagValue}
        />
      </Arrange>
    </Container>
  );
}
